<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    :class="
      twJoin(
        'h-6 w-9 border-[4px] rounded-3xl border-black relative flex items-center cursor-pointer transition-all ease-in-out',
        props.checked ? 'bg-black' : 'bg-white'
      )
    "
    @click="() => emit('change', !props.checked)"
  >
    <div
      :class="
        twJoin(
          'w-3 h-3 rounded-full absolute transition-all ease-in-out',
          props.checked ? 'bg-white right-[2px]' : 'bg-black left-[2px]'
        )
      "
    />
  </div>
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'
const emit = defineEmits<{
  (e: 'change', value: boolean): void
}>()

const props = defineProps<{
  checked?: boolean
}>()
</script>
